var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.profileInfo)?_c('user-profile',{attrs:{"is-new-profile":false,"user-profile-information":_vm.profileInfo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }